import { useParams, Link } from "react-router-dom";
import SEO from "@/components/base/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ScrollToTop from "@/components/feature/ScrollToTop";
import { categories } from "@/mocks/categories";
import { videoData } from "@/mocks/videos";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();

  const category = categories.find((c) => c.slug === slug);
  const categoryVideos = videoData.filter(
    (v) => v.category === category?.name
  );

  if (!category) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <h1 className="text-2xl font-heading text-foreground-800 mb-4">分类未找到</h1>
            <Link to="/" className="text-primary-500 hover:text-primary-600 cursor-pointer">
              返回首页
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const otherCategories = categories.filter((c) => c.slug !== slug);

  return (
    <>
      <ScrollToTop />
      <SEO
        title={`${category.name} - 玫瑰视频高清在线观看 | ${category.name}大全免费`}
        description={`玫瑰视频${category.name}频道：${category.description} 汇集${category.count}部${category.name}资源，高清免费在线观看。`}
        keywords={`玫瑰视频,${category.name},高清在线观看,免费${category.name},最新${category.name}`}
        canonicalUrl={`https://meiguishipin.com/category/${category.slug}`}
      />

      <Navbar />

      <main className="pt-20 pb-14">
        <div className="max-w-7xl mx-auto">
          <Breadcrumb
            items={[
              { name: "首页", path: "/" },
              { name: category.name },
            ]}
          />

          <div className="px-4 md:px-6">
            <div className="mb-8">
              <h1 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-3">
                {category.name}
              </h1>
              <p className="text-sm text-foreground-500 max-w-2xl">
                {category.description}
              </p>
            </div>

            <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 flex-wrap">
              <span className="text-xs text-foreground-500 whitespace-nowrap">分类切换：</span>
              {otherCategories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="px-3 py-1.5 bg-background-100 text-foreground-600 hover:bg-background-200 text-xs rounded-full whitespace-nowrap cursor-pointer transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
              {categoryVideos.map((video) => (
                <Link
                  key={video.id}
                  to={`/article/${video.id}`}
                  className="group cursor-pointer"
                >
                  <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200 mb-3">
                    <img
                      src={video.image}
                      alt={video.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                      title={`${video.title} - ${video.category}高清在线观看`}
                    />
                    <div className="absolute top-2 left-2">
                      <span className="px-2 py-0.5 bg-primary-500 text-white text-xs rounded-md font-medium">
                        {video.rating}
                      </span>
                    </div>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">
                    {video.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-xs text-foreground-500">{video.source}</span>
                    <span className="text-xs text-foreground-400">{video.year}</span>
                  </div>
                </Link>
              ))}
            </div>

            {categoryVideos.length === 0 && (
              <div className="text-center py-20">
                <p className="text-foreground-500">该分类暂无内容，敬请期待</p>
              </div>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}